var map = {
	"./4g.svg": 100,
	"./Balance_32.svg": 320,
	"./Block_24.svg": 321,
	"./Calendar_16.svg": 322,
	"./Change-sim-card_32.svg": 323,
	"./Family_32.svg": 324,
	"./Infinity_24.svg": 325,
	"./Router_3.svg": 326,
	"./Settings_24.svg": 327,
	"./Sim-card_24.svg": 328,
	"./Support-avatar_32.svg": 329,
	"./TV2.svg": 330,
	"./TV_bold.svg": 331,
	"./Whats-left_24.svg": 332,
	"./amediateka.svg": 333,
	"./amediateka_head.svg": 334,
	"./app_store.svg": 335,
	"./arrow-green-l.svg": 336,
	"./arrow-select.svg": 337,
	"./arrow.green-r.svg": 338,
	"./arrow.svg": 339,
	"./arrow_slider.svg": 340,
	"./back.svg": 341,
	"./bonus.svg": 342,
	"./check.svg": 343,
	"./chromecast.svg": 344,
	"./close-round.svg": 345,
	"./close.svg": 346,
	"./cpu-24.svg": 347,
	"./crystal.svg": 348,
	"./download-pdf.svg": 57,
	"./fiolet_4k.svg": 349,
	"./fiolet_block.svg": 350,
	"./fiolet_googleplay.svg": 351,
	"./fiolet_hertz.svg": 352,
	"./fiolet_mobile-internet.svg": 353,
	"./fiolet_pult.svg": 354,
	"./fiolet_razmer.svg": 355,
	"./fiolet_router.svg": 356,
	"./fiolet_settings.svg": 357,
	"./fiolet_speed.svg": 358,
	"./fiolet_umnyj-dom.svg": 359,
	"./fiolet_video.svg": 360,
	"./fiolet_voice-message.svg": 361,
	"./fiolet_wi-fi.svg": 362,
	"./fiolet_zone.svg": 363,
	"./geo.svg": 364,
	"./google-play.svg": 365,
	"./google_play.svg": 366,
	"./hertz_24.svg": 367,
	"./hertz_24_w.svg": 368,
	"./info.svg": 369,
	"./invalid.svg": 370,
	"./location.svg": 371,
	"./mess.svg": 372,
	"./message.svg": 373,
	"./mf_logo_full.svg": 374,
	"./mf_tv.svg": 375,
	"./mftv_amediateka.svg": 133,
	"./mftv_mf-tv.svg": 134,
	"./mftv_more.svg": 135,
	"./mftv_start.svg": 136,
	"./mic.svg": 376,
	"./mob_bold.svg": 377,
	"./mobile.svg": 99,
	"./more.svg": 378,
	"./phone_24.svg": 379,
	"./pult.svg": 380,
	"./safety.svg": 381,
	"./socket.svg": 382,
	"./speed-2.svg": 383,
	"./speed-2_w.svg": 384,
	"./speedtest-awards.svg": 91,
	"./start.svg": 385,
	"./success.svg": 101,
	"./tel.svg": 386,
	"./tv.svg": 98,
	"./wi-fi.svg": 97,
	"./wi-fi_bold.svg": 387,
	"./zone-24.svg": 388,
	"./zone-24_w.svg": 389
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87;